import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';
import bannerWordsRefine from '../utils/bannedWordsRefine';

import { InputModalFieldElement } from './InputModalField';
import type { InputModalField as InputModalFieldType } from './types';

const createValidationSchema = (field: InputModalFieldType) => {
  let fieldSchema: ZodTypeAny = z
    .string({
      required_error: `${
        field.label.charAt(0).toUpperCase() + field.label.slice(1).toLowerCase()
      } is required`,
    })
    .trim();

  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  } else {
    // @ts-expect-error Not sure how to type this
    fieldSchema = fieldSchema.min(1, {
      message: `${
        field.label.charAt(0).toUpperCase() + field.label.slice(1).toLowerCase()
      } is required`,
    });
  }

  if (field.validation?.minLength) {
    // @ts-expect-error Not sure how to type this
    fieldSchema = fieldSchema.min(field.validation.minLength, {
      message: `${field.label} must be at least ${field.validation.minLength} characters`,
    });
  }

  if (field.validation?.maxLength) {
    // @ts-expect-error Not sure how to type this
    fieldSchema = fieldSchema.max(field.validation.maxLength, {
      message: `${field.label} must be at most ${field.validation.maxLength} characters`,
    });
  }

  if (field.validation?.bannedWords) {
    fieldSchema = fieldSchema.refine(bannerWordsRefine(field.validation.bannedWords), (value) => ({
      message: `Your ${field.label.toLowerCase()} cannot contain the following phrase: ${value}`,
    }));
  }

  if (field.validation?.bannedWordsHidden) {
    fieldSchema = fieldSchema.refine(
      bannerWordsRefine(field.validation.bannedWordsHidden, field.validation.softWords, {
        cleanValue: false,
      }),
      {
        message: `Your ${field.label.toLowerCase()} has a word or phrase that you cannot use.`,
      }
    );
  }

  return fieldSchema;
};

const Descriptor: FieldDescriptor<InputModalFieldType> = {
  FieldComponent: InputModalFieldElement,
  name: 'InputModalField',
  createValidationSchema,
};

export default Descriptor;

export type { InputModalFieldType };

